<ng-container *ngIf="!loading; else isLoading">
  <ng-container
    *ngIf="actionItems && actionItems.length > 0; else noActionItems">
    <div class="items-container">
      <div *ngFor="let actionItem of actionItems" class="card mb-4">
        <div class="card-header border-bottom d-flex justify-content-between">
          <p class="fw-bold mb-0">{{ actionItem.content }}</p>
          <div class="tools">
            <button
              (click)="editActionItem(actionItem.id)"
              title="Edit To Do"
              class="btn btn-link me-2 p-0">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button
              aria-label="delete to do button"
              class="btn btn-delete p-0"
              type="button"
              [autoClose]="'outside'"
              [ngbPopover]="deleteContent"
              [popoverTitle]="'Delete To Do'"
              #popover="ngbPopover">
              <i class="bi bi-trash"></i>
            </button>
            <ng-template #deleteContent>
              Are you sure you want to delete this To Do?
              <div class="text-end mt-2">
                <button
                  type="button"
                  class="btn btn-secondary btn-sm px-3 m-1"
                  (click)="popover.close()">
                  No
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-sm px-3 m-1"
                  (click)="deleteActionItem(actionItem.id); popover.close()">
                  Yes
                </button>
              </div>
            </ng-template>
          </div>
        </div>
        <div class="card-body">
          <app-safehtml [html]="actionItem.description"></app-safehtml>
        </div>
        <div
          class="card-footer bg-white d-flex justify-content-between align-items-center">
          <div class="d-flex flex-column flex-md-row align-items-md-center">
            <span class="fw-bold me-2 assignee-label">Assignee:</span>
            <app-todo-assignee [userId]="actionItem.userId"></app-todo-assignee>
          </div>
          <span class="fw-light text-body-secondary">{{
            actionItem.dueDate | formatDate
          }}</span>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #noActionItems>
    <p class="text-body-secondary fw-light m-3">
      No To Dos have been created yet.<br /><br />Get started by clicking “+ Add
      To Do” to stay organized and productive. All tasks will show up on the
      assignee's To Do list on their dashboard
    </p>
  </ng-template>
</ng-container>
<ng-template #isLoading>
  <div class="w-100" style="background-color: #fff; height: 700px">
    <app-loader></app-loader>
  </div>
</ng-template>
<app-modal
  #actionPlanModal
  [modalConfig]="{
    titleText: 'To Do',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    windowClass: 'custom-class',
    customFooter: true
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="actionPlanModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <form class="form-wrapper" [formGroup]="actionItemForm">
    <label for="title" class="form-label">Title</label>
    <div class="input-group">
      <input
        formControlName="title"
        type="text"
        class="form-control"
        id="title"
        aria-label="Title" />
    </div>
    <label for="description" class="form-label">Description</label>
    <app-wysiwyg-editor #editor [version]="'mini'" [config]="editorConfig" />
    <label for="assignee" class="form-label">Assignee</label>

    <app-user-select
      #userSelect
      (selectedUser)="selectUserEdit($event)"
      (selectedUserList)="selectUserChange($event)"
      [isMulti]="true"></app-user-select>

    <label for="dueDate" class="form-label">Due Date</label>
    <app-datepicker
      #datepicker
      (dateSelectedUnixTimestamp)="
        selectedDate.next($event[0].time / 1000)
      "></app-datepicker>
  </form>
  <div footerContent>
    <div class="d-flex justify-content-between">
      <button type="button" class="btn" (click)="actionPlanModal.close()">
        Cancel
      </button>
      <ng-container *ngIf="actionType === 'create'">
        <ng-container
          *ngIf="
            actionItemForm.invalid ||
              checkIfEditorEmpty() ||
              selectedUserIds.length === 0 ||
              (userSelect.selectedUserList &&
                userSelect.selectedUserList.length === 0);
            else valid
          "
          ><span ngbTooltip="All fields are required">
            <button
              type="button"
              class="btn btn-md btn-primary xxbtn-fake-disabled xxdisabled"
              disabled>
              Create
            </button></span
          >
        </ng-container>
        <ng-template #valid>
          <button
            (click)="saveActionItem(); actionPlanModal.close()"
            type="button"
            class="btn btn-md btn-primary">
            Create
          </button>
        </ng-template>
      </ng-container>
      <button
        *ngIf="actionType === 'edit'"
        (click)="saveActionItem(); actionPlanModal.close()"
        type="button"
        class="btn btn-md btn-primary"
        [disabled]="
          actionItemForm.invalid ||
          checkIfEditorEmpty() ||
          (userSelect.selectedUserList &&
            userSelect.selectedUserList.length === 0)
        ">
        Save
      </button>
    </div>
  </div>
</app-modal>
